<template>
    <div class="goods-info-content">
        <el-table :data="studentSubmitList" class="customTable" style="width: 100%; flex: 1; margin-top: 20px" height="1%">
            <el-table-column prop="content" label="学生名字"></el-table-column>
            <el-table-column prop="content" label="考试名称"></el-table-column>
            <el-table-column label="考试模块" align="center">
                <template slot-scope="scope">
                    <span>商品主图</span>
                </template>
            </el-table-column>
            <el-table-column prop="content" label="状态"></el-table-column>
            <el-table-column prop="content" label="考试时间"></el-table-column>
            <el-table-column label="评分（最高分数为20分）" align="center">
                <template slot-scope="scope">
                    <div class="link-box">
                        <el-link type="success" :underline="false" @click="viewGoodsImg(scope.row)" class="view-detail">查看详情</el-link>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <div class="link-box">
                        <el-link type="success" :underline="false" @click="viewGoodsImgs(scope.row)" class="view-detail">查看详情</el-link>
                        <el-link type="success" :underline="false" @click="viewGrading(scope.row)" class="view-detail">评分标准</el-link>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pager-center" style="margin: 20px;text-align: center"
                       :current-page="studentSubmitPages.currentPageNum"
                       :page-size="studentSubmitPages.eachPageNum"
                       :total="studentSubmitPages.total"
                       layout="prev, pager, next, jumper"
                       @current-change="studentSubmitCurrentChange">
        </el-pagination>
        <el-dialog title="商品主图" :visible.sync="goodsImgsDialog" width="764px" @close="handleCloseGoodsImgsDialog" custom-class="green-dialog goods-img-dialog">
            <div class="upload-file-content">
                <div class="big-img">
                    <img src="../../../assets/images/user_img.png" alt="">
                </div>
                <div class="small-img">
                    <img src="../../../assets/images/user_img.png" alt="" @click="viewBigImgs">
                    <img src="../../../assets/images/user_img.png" alt="">
                    <img src="../../../assets/images/user_img.png" alt="">
                    <img src="../../../assets/images/user_img.png" alt="">
                    <img src="../../../assets/images/user_img.png" alt="">
                    <img src="../../../assets/images/user_img.png" alt="">
                    <img src="../../../assets/images/user_img.png" alt="">
                </div>
            </div>
        </el-dialog>
        <el-dialog title="评分标准"
                   :visible.sync="gradingDialog" width="830px" @close="handleCloseGradingDialog" custom-class="green-dialog goods-score-dialog">
            <div class="upload-file-content">
                <el-table :data="gradingList" class="customTable goods-text-table" style="width: 100%; flex: 1;" height="1%"
                          :header-cell-style="{fontWeight: 'normal', height: '40px', color: '#333', background: '#F2F3FA',fontSize: '14px'}"
                          :cell-style="{fontSize: '14px',color: '#333333',height: '40px'}">
                    <el-table-column prop="name" label="评委" align="center"></el-table-column>
                    <el-table-column prop="score" label="考核内容" align="center"></el-table-column>
                    <el-table-column prop="time" label="考核要点" align="center"></el-table-column>
                    <el-table-column prop="time" label="评分标准" align="center"></el-table-column>
                    <el-table-column prop="time" label="配分" align="center"></el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "Index",
        data() {
            return {
                //学生提交列表
                studentSubmitList: [
                    {}
                ],
                //商品主图弹窗
                goodsImgsDialog: false,
                //评分标准列表
                gradingList: [
                    {}
                ],
                //评分标准弹窗
                gradingDialog: false,
                //分页
                studentSubmitPages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0
                }
            }
        },
        methods: {
            //查看商品主图
            viewGoodsImgs() {
                this.goodsImgsDialog = true;
            },
            //查看大图
            viewBigImgs() {

            },
            //关闭商品主图弹窗
            handleCloseGoodsImgsDialog() {
                this.goodsImgsDialog = false;
            },
            //下载文件
            downloadFile() {

            },
            //查看评分标准
            viewGrading() {
                this.gradingDialog = true;
            },
            //关闭评分标准弹窗
            handleCloseGradingDialog() {
                this.gradingDialog = false;
            },
            //分页
            studentSubmitCurrentChange() {

            }
        }
    }
</script>

<style scoped lang="scss">
    .goods-info-content {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 0 20px;
        .link-box {
            .view-detail {
                ::v-deep .el-link--inner {
                    color: #1AB163;
                }
            }
        }
        .goods-img-dialog {
            .upload-file-content {
                display: flex;
                justify-content: space-between;
                width: 100%;
                height: 445px;
                .big-img {
                    width: 444px;
                    height: 444px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .small-img {
                    flex: 1;
                    width: 1%;
                    margin-left: 94px;
                    img {
                        width: 80px;
                        height: 80px;
                        margin-bottom: 15px;
                        border: 2px solid transparent;
                        box-sizing: border-box;
                        &:nth-child(2n-1) {
                            margin-right: 18px;
                        }
                        &:hover {
                            cursor: pointer;
                            border: 2px solid #2DC079;
                        }
                    }
                }
            }
        }
    }
</style>